module.exports = __webpack_public_path__ + "static/media/404.995be234.svg";